<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import utilsService from '@/services/core/utils.service';
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import ButtonSpinner from '@/components/shared/ButtonSpinner';
    import { DxColumn } from 'devextreme-vue/data-grid';
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import DataSource from 'devextreme/data/data_source';

    const demoCompanyId = 1241;

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            AdminGrid,
            DxColumn,
            DxSelectBox,
            ButtonSpinner
        },
        data() {
            return {
                companyId: 0,
                filter: '',
                isLoading: 0,
                result: [],
                companiesLoaded: true,
                companiesDs: {}
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            save() {
                const selectedBatteries = this.$refs['destinationBatteryGrid'].getSelectedRowKeys();
                const destinationBatteryIds = selectedBatteries.map(b => b.id) || [];

                if (destinationBatteryIds.length == 0) {
                    utilsService.showToast('You must provide at least one source battery.', 'error');
                    return;
                }

                const url = `demo-settings/${demoCompanyId}`;

                this.isLoading++;
                httpService
                    .post(url, destinationBatteryIds)
                    .then(() => {
                        utilsService.showToast('data saved successfully');
                        this.modalData.onSuccess && this.modalData.onSuccess();
                        this.close();
                    })
                    .finally(() => this.isLoading--);
            },
            loadCompanies() {
                this.companiesLoaded = false;

                const url = `companies`;

                httpService
                    .get(url)
                    .then(data => {
                        this.companiesDs = new DataSource({
                            key: 'id',
                            store: data.filter(c => c.id != demoCompanyId),
                            paginate: true,
                            pageSize: 10
                        });
                    })
                    .finally(() => (this.companiesLoaded = true));
            },
            loadBatteries(e) {
                const url = `companies/${e.value.id}/batteries`;

                this.isLoading++;

                httpService
                    .get(url)
                    .then(data => {
                        this.result = data;
                    })
                    .finally(() => this.isLoading--);
            }
        },
        mounted() {
            this.loadCompanies();
        }
    };
</script>

<template>
    <Modal sizeClass="modal-lg">
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Select Batteries</h3>
                </div>
                <div class="modal-body">
                    <div class="row mb-3">
                        <label class="col-sm-3 col-form-label">Company</label>
                        <div class="col-sm">
                            <DxSelectBox
                                :data-source="companiesDs"
                                display-expr="name"
                                :search-enabled="true"
                                search-mode="contains"
                                search-expr="name"
                                :search-timeout="200"
                                drop-down-button-template="loadIcon"
                                @value-changed="loadBatteries"
                            >
                                <template #loadIcon="{}">
                                    <div>
                                        <span v-show="!companiesLoaded" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                    </div>
                                </template>
                            </DxSelectBox>
                        </div>
                    </div>
                    <div v-if="isLoading > 0">Loading...</div>
                    <AdminGrid
                        v-if="isLoading == 0"
                        :data-source="result"
                        :showActions="false"
                        :showFilters="false"
                        :showExport="false"
                        :showSelection="true"
                        :showToolbar="false"
                        ref="destinationBatteryGrid"
                    >
                        <DxColumn data-field="id" />
                        <DxColumn data-field="name" />
                        <DxColumn data-field="type" />
                        <DxColumn data-field="state" />
                        <DxColumn data-field="identifier" />
                        <DxColumn data-field="status" />
                    </AdminGrid>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                    <ButtonSpinner :isLoading="isLoading" text="Save" />
                </div>
            </div>
        </form>
    </Modal>
</template>
